import { render, staticRenderFns } from "./PrintPositionen.vue?vue&type=template&id=12645b7a&scoped=true"
import script from "./PrintPositionen.vue?vue&type=script&lang=js"
export * from "./PrintPositionen.vue?vue&type=script&lang=js"
import style0 from "./PrintPositionen.vue?vue&type=style&index=0&id=12645b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12645b7a",
  null
  
)

export default component.exports